import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Icon,
  Box,
  HStack,
  Flex,
  useColorModeValue,
  Badge,
  Divider,
  ModalCloseButton,
} from '@chakra-ui/react';
import {
  FaCcVisa,
  FaCcMastercard,
  FaCcAmex,
  FaCcDiscover,
  FaCreditCard,
  FaStar,
} from 'react-icons/fa6';
import StripeLinkLogo from '../../../common/StripeLinkLogo';

const SetDefaultPaymentMethodModal = ({
  isOpen,
  onClose,
  paymentMethod,
  onConfirm,
  isLoading = false,
}) => {
  const bgColorHighlight = useColorModeValue('blue.50', 'blue.900');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  const getCardIcon = (brand) => {
    const brands = {
      visa: FaCcVisa,
      mastercard: FaCcMastercard,
      amex: FaCcAmex,
      discover: FaCcDiscover,
    };

    return brands[brand?.toLowerCase()] || FaCreditCard;
  };

  const handleConfirm = () => {
    onConfirm(paymentMethod.id);
  };

  if (!paymentMethod) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent pt={10} pb={6} px={6}>
        <ModalCloseButton />
        <Text textStyle="heading4" textAlign="center">
          Make default card
        </Text>
        <Divider my="10px" />
        <ModalBody>
          <Text textStyle="bodyMedium" mb={4}>
            Are you sure you want to set the following card as your default
            payment method?
          </Text>
          <Text textStyle="bodyMedium" mb={4}>
            This will be used for all future payments and subscription renewals.
          </Text>

          {/* Payment method preview */}
          <Box
            p={4}
            borderWidth="1px"
            borderRadius="md"
            borderColor={borderColor}
            bg={bgColorHighlight}
            mb={4}
          >
            <Flex align="center">
              {paymentMethod.type !== 'link' && (
                <Icon
                  as={getCardIcon(
                    paymentMethod.card?.brand || paymentMethod.brand
                  )}
                  boxSize="24px"
                  mr={3}
                  color="blue.500"
                />
              )}
              <Box>
                <HStack>
                  {paymentMethod.type === 'link' ? (
                    <Box color="gray.800">
                      <StripeLinkLogo height="20px" />
                    </Box>
                  ) : (
                    <Text textStyle="bodyMedium">
                      {paymentMethod.card?.brand ||
                        paymentMethod.brand ||
                        'Card'}{' '}
                      •••• {paymentMethod.card?.last4 || paymentMethod.last4}
                    </Text>
                  )}
                  <Badge colorScheme="yellow" variant="subtle">
                    <HStack spacing={1}>
                      <Icon as={FaStar} fontSize="xs" />
                      <Text>New Default</Text>
                    </HStack>
                  </Badge>
                </HStack>
                {paymentMethod.type === 'link'
                  ? paymentMethod.email && (
                      <Text textStyle="bodySmall" color="gray.600">
                        {paymentMethod.email}
                      </Text>
                    )
                  : (paymentMethod.card?.exp_month ||
                      paymentMethod.exp_month) && (
                      <Text textStyle="bodySmall" color="gray.600">
                        Expires{' '}
                        {paymentMethod.card?.exp_month ||
                          paymentMethod.exp_month}
                        /
                        {paymentMethod.card?.exp_year || paymentMethod.exp_year}
                      </Text>
                    )}
              </Box>
            </Flex>
          </Box>
        </ModalBody>

        <ModalFooter>
          <Flex direction="column" w="100%" gap={4}>
            <Button
              colorScheme="blue"
              onClick={handleConfirm}
              isLoading={isLoading}
              leftIcon={<Icon as={FaStar} />}
              w="100%"
            >
              Set as Default
            </Button>

            <Button variant="link" onClick={onClose} isDisabled={isLoading}>
              <Text textStyle="bodySmall">Cancel</Text>
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SetDefaultPaymentMethodModal;
